<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
import VSwitch from "@magnit/core/src/components/VSwitch/VSwitch.vue";

const modelValue = defineModel<boolean>({ default: false });
</script>

<template>
  <div class="filter-discount">
    <VText font="title-small"> Со скидкой </VText>
    <VSwitch v-model="modelValue" />
  </div>
</template>

<style scoped lang="postcss">
.filter-discount {
  background-color: var(--pl-surface-muted-default);
  padding: var(--pl-unit-x4) var(--pl-unit-x2) var(--pl-unit-x4)
    var(--pl-unit-x4);
  border-radius: var(--pl-unit-x4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--pl-unit-x4);
}
</style>
